import { render, staticRenderFns } from "./ProductNameTypeEdit.vue?vue&type=template&id=dc54cdcc&scoped=true&"
import script from "./ProductNameTypeEdit.vue?vue&type=script&lang=js&"
export * from "./ProductNameTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc54cdcc",
  null
  
)

export default component.exports